import { ChangeEvent } from 'react';
import { FilterParams } from '@synergy/models';
import { FormattedMessage } from 'react-intl';
import { PoolTextField, useFilter } from '@synergy/components';

export const MaxPriceChangeRatioFilter = () => {
    const { filter, updateFilter, registerFilterMap } = useFilter();

    const handleChange = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const maxPriceChangeRatio: number = +event.target.value;
        filter.delete(FilterParams.MaxPriceChangeRatio);
        if (!isNaN(maxPriceChangeRatio)) {
            filter.set(FilterParams.MaxPriceChangeRatio, (maxPriceChangeRatio / 100).toString());
        }
        updateFilter(filter);
    };

    registerFilterMap(FilterParams.MaxPriceChangeRatio, value => (value as number) * 100);

    const ratio = filter.get(FilterParams.MaxPriceChangeRatio);
    return (
        <PoolTextField
            fullWidth={true}
            label={<FormattedMessage id="app.label.maxPriceChangeRatio" />}
            value={ratio && +ratio * 100}
            onChange={handleChange}
            isNumeric={true}
        />
    );
};
